import React, {} from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Example } from 'components';
import i18n from 'i18next';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 20px;
`;

const ExmapleBlockUserGroup = () => {
	const { t } = useTranslation();

	return (
		<>

			<Container>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/UserGroupRequest.xsd'} title={t('Схема запроса')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/UserGroupResponse.xsd'} title={t('Схема ответа')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/UserGroupCreateRequest.xml'} title={t('Пример запроса') + ' ' + t('Создать')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/UserGroupCreateResponse.xml'} title={t('Пример успешного') + ' ' + t('Создать')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/UserGroupUpdateRequest.xml'} title={t('Пример запроса') + ' ' + t('Обновить')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/UserGroupUpdateResponse.xml'} title={t('Пример успешного') + ' ' + t('Обновить')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/UserGroupDeleteRequest.xml'} title={t('Пример запроса') + ' ' + t('Удалить')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/UserGroupDeleteResponse.xml'} title={t('Пример успешного') + ' ' + t('Удалить')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/UserGroupRequest.xml'} title={t('Пример запроса') + ' ' + t('Список')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/UserGroupResponse.xml'} title={t('Пример успешного') + ' ' + t('Список')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/UserGroupResponseError.xml'} title={t('Пример ответа с ошибкой')}/>

			</Container>
		</>
	);
};

export default ExmapleBlockUserGroup;